import { render, staticRenderFns } from "./OtroPago.vue?vue&type=template&id=49e5ba34&"
import script from "./OtroPago.vue?vue&type=script&lang=js&"
export * from "./OtroPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports